module.exports = __webpack_public_path__ + "img/login-background.0ddb199e.jpg";